<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  'exhibition-product-allproduct',
  data() {
    return {

    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 上传产品";
  }
}
</script>

<style scoped lang="scss">

</style>
